<div  [@showHide]="(hidden$ | async) ? 'hide' : 'show'">
    <fui-button
        [title]="appService.language_dictionary.system_to_top"
        (clickEvent)="scrollToTop()"
        color="light"
        height="mini"
        type="button-icon"
        icon="arrow-up-bold">
    </fui-button>
</div>
